import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=28c3d49e&scoped=true&"
import script from "./EditProject.vue?vue&type=script&lang=js&"
export * from "./EditProject.vue?vue&type=script&lang=js&"
import style0 from "./EditProject.vue?vue&type=style&index=0&id=28c3d49e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3d49e",
  null
  
)

component.options.__file = "EditProject.vue"
export default component.exports